import { mergedSystems } from './system-merge.js';
import { KNOWN_ROM_SYSTEMS, LISTED_TYPES } from './release-type-vocabulary.js';

export const RELEASE_TYPE_OVERRIDES = Object.freeze([
  { system: 'genesis', hash: 'dd0acec8', release_type: 'hack', note: 'Madden NFL 95 Superbowl Hack' },
  { system: 'genesis', hash: '2fa22128', release_type: 'hack', note: 'Sonic 1 Gaslight' },
  { system: 'genesis', hash: '7801d167', release_type: 'hack', note: 'Sonic 1 Spindash' },
  { system: 'nes', hash: '7c7b0eec', release_type: 'hack', note: 'Dragon Warrior CRTJ' },
  { system: 'nes', hash: 'a17f60ec', release_type: 'hack', note: 'Dragon Warrior EDS' },
  { system: 'nes', hash: '5af088f8', release_type: 'hack', note: 'Dragon Warrior III Special Ed V0.5' },
  { system: 'gb', hash: '61148d44', release_type: 'hack', note: 'Castlevania Adventure graphics hack' },
  { system: 'nes', hash: '14a7dcbc', release_type: 'hack', note: 'Earth Bound Zero Neo Demiforce' },
  { system: 'snes', hash: '8ef6df50', release_type: 'hack', note: '10 Yard Fight A&S NES Hack' },
].map((entry) => Object.freeze(entry)));

const HASH_RE = /^[0-9a-f]{8}$/u;
const knownSystems = new Set(KNOWN_ROM_SYSTEMS);
const listedTypes = new Set(LISTED_TYPES);

export class ReleaseTypeOverrideError extends Error {
  constructor(errors) {
    super(`Invalid release-type overrides: ${errors.map(({ index, reason }) => `${index}:${reason}`).join(', ')}`);
    this.name = 'ReleaseTypeOverrideError';
    this.errors = errors;
  }
}

export function validateReleaseTypeOverrides(entries) {
  if (!Array.isArray(entries)) {
    return { overrides: new Map(), errors: [{ index: -1, reason: 'malformed_entry' }] };
  }
  const overrides = new Map();
  const errors = [];
  entries.forEach((entry, index) => {
    if (!entry || typeof entry !== 'object' || Array.isArray(entry)
      || typeof entry.system !== 'string' || typeof entry.hash !== 'string'
      || typeof entry.release_type !== 'string') {
      errors.push({ index, reason: 'malformed_entry' });
      return;
    }
    if (!knownSystems.has(entry.system)) {
      errors.push({ index, reason: 'unknown_system' });
      return;
    }
    if (!HASH_RE.test(entry.hash)) {
      errors.push({ index, reason: 'malformed_hash' });
      return;
    }
    if (!listedTypes.has(entry.release_type)) {
      errors.push({ index, reason: 'unknown_type' });
      return;
    }
    const key = `${mergedSystems(entry.system)[0]}:${entry.hash}`;
    if (overrides.has(key)) {
      errors.push({ index, reason: 'duplicate_key' });
      return;
    }
    overrides.set(key, entry.release_type);
  });
  return { overrides, errors };
}

const validated = validateReleaseTypeOverrides(RELEASE_TYPE_OVERRIDES);
if (validated.errors.length) throw new ReleaseTypeOverrideError(validated.errors);
const OVERRIDES = validated.overrides;

export function overrideTypeFor(system, hash) {
  if (!knownSystems.has(system) || typeof hash !== 'string' || !HASH_RE.test(hash)) return null;
  return OVERRIDES.get(`${mergedSystems(system)[0]}:${hash}`) ?? null;
}
